<template>
    <editor-page class="cms-admin" :loading="loading">
        <b-container class="text-left">
            <h4 v-tr>Websites|Sites internet</h4>
            <div class="websites">
                <b-card class="card-website simple" v-for="website in websites" :key="website.id">
                    <div>
                        <b-img v-if="website && website.design" width="32" class="mr-2 d-inline-flex" :src="website.design?.favicon?.src"/>
                        <div class="d-inline-flex" style="flex-direction: column">
                            <h5>{{website.name}}</h5>
                            <small>{{website.domain}}</small>
                        </div>
                    </div>
                    <div class="mt-2 text-right">
                        <b-btn size="sm" variant="light" class="mr-2" @click="previewWebsite(website)" target="_blank">
                            <i class="fas fa-external-link-alt mr-1"/>
                            <span v-tr>Open|Ouvrir</span>
                        </b-btn>
                        <b-btn size="sm" @click="editWebsite(website)">
                            <i class="fas fa-edit mr-1"/>
                            <span v-tr>Edit|Modifier</span>
                        </b-btn>
                    </div>
                </b-card>
            </div>
        </b-container>
    </editor-page>
</template>

<script>
import NetworkV2 from "@vue-components/helpers/NetworkV2.js";
import EditorPage from "../layout/editor-page.vue";
import store from "../store.js";

// web-editor
export default {
    name: `cms-admin`,
    components: {
        EditorPage
    },
    data() {
        return {
            loading: false,
            websites: null
        }
    },
    activated() {
        this.getWebsites();
    },
    methods: {
        getWebsites() {
            NetworkV2.get(`/api/websites/list`)
                .then(resp => {
                    this.websites = resp.data;
                })
        },
        async editWebsite(website) {
            await this.loadWebsite(website);
            if (this.cmsWebsite) {
                const homePage = this.cmsWebsite.getHomePage();
                this.$router.push(`/cms/editor/website/${this.cmsWebsite.id}/${homePage.id}`);
            }
        },
        async previewWebsite(website) {
            await this.loadWebsite(website);
            if (this.cmsWebsite) {
                const homePage = this.cmsWebsite.getHomePage();
                window.location.href = this.cmsWebsite.getPreviewUrl(homePage);
            }
        },
        async loadWebsite(website) {
            try {
                this.showLoading();
                store.state.applicationReady = false;
                const response = await NetworkV2.get(`/api/website/${website.id}`);
                this.$store.commit(`setWebsite`, response.data);
                store.state.applicationReady = true;
                this.hideLoading();
            } catch(error) {
                this.showErrorFeedback(error);
            }
        }
    }
}
</script>

<style lang="scss">
.websites {
    gap: 10px;
    display: grid;
    grid-template-columns: repeat( auto-fit, minmax(350px, 1fr) );
}

.card-website {
    max-width: 100%;
    display: inline-flex;
}
</style>
